import { II18n } from '@ifit/rapport-webview';

export const CARDSIZE = {
  SMALL: 'small',
  LARGE: 'large',
};
export type CardSize = typeof CARDSIZE[keyof typeof CARDSIZE];

export const CARDTYPE = {
  SERIES: 'series',
  TRAINER: 'trainer',
  WORKOUT: 'workout',
};
export type CardType = typeof CARDTYPE[keyof typeof CARDTYPE];

export type Rating = {
  average: number;
};

export type Estimates = {
  calories: number | string;
  distance: number | string;
  time: number | string;
};

export type ProgramInfo = {
  currentWorkoutIndex: number;
  seriesId: string;
  seriesTitle: string;
  total: number;
  weekIndex: number;
};

export type CardData = {
  image: string;
  intensity: number;
  itemId: string;
  title: string;
  estimates?: Estimates;
  lastCompleted?: string;
  programId?: string;
  rating?: Rating;
  workoutType?: string;
};

export type TrainerData = {
  availableWorkouts: number;
  name: string;
  topCategories?: string[];
  topWorkoutImages?: string[];
  image?: string;
  itemId?: string;
};
export interface IWorkoutCardProps {
  data: CardData;
  cardSize?: CardSize;
  category?: string;
  disableNative?: boolean;
  equipmentType?: string;
  fallbackImage?: string;
  forceFallbackImg?: boolean;
  horizontal?: boolean;
  lineWrapBasedOn?: 'words' | 'letters';
  locked?: boolean;
  overlayText?: string;
  programInfo?: ProgramInfo;
  recommendationLabel?: string;
  themeClass?: string;
  useMetricUnits?: boolean;
  verbose?: boolean;
}

export type CardSeriesData = CardData & {
  workouts: string[];
};

export interface ISeriesCardProps extends IWorkoutCardProps {
  data: CardSeriesData;
  isChallenge?: boolean;
  recommendationLabel?: string;
}

export interface ICardsProps
  extends Omit<ISeriesCardProps, 'data' | 'workouts'> {
  cardType: CardType;
  data: CardData | CardSeriesData | TrainerData;
  workouts?: string[];
}
